<div class="upload-dialog">
  <div class="dialog-header">
    <div>Upload a document</div>
    <div class="dialog-text">Please upload your document here.</div>
  </div>
  <input type="file" class="no-display" (change)="uploadDocument($event.target.files[0])" [attr.accept]="acceptedTypes" #upload>
  <div class="dialog-buttons">
    <button type="button" class="upload-upload d-form-btn-browse d-form-btn-style d-form-btn-text" (click)="upload.click()">
      Browse
    </button>
    <button type="button" class="upload-upload d-form-btn d-form-btn-style d-form-btn-text" (click)="cancel()">
      Cancel
    </button>
  </div>
</div>